import styled, { keyframes } from 'styled-components';

// Animações para a entrada e saída do modal
const fadeIn = keyframes`
  from {
    transform: scale(0.95) translateY(20px);
    opacity: 0;
  }
  to {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
  to {
    transform: scale(0.95) translateY(20px);
    opacity: 0;
  }
`;

const fadeOutOverlay = keyframes`
  from {
    background-color: rgba(0, 0, 0, 0.6);
  }
  to {
    background-color: rgba(0, 0, 0, 0);
  }
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  &.closing {
    animation: ${fadeOutOverlay} 0.4s forwards;
  }
`;

export const ModalContainer = styled.div`
  background-color: #ffffff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 600px;
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
  box-sizing: border-box;
  @media (max-width: 768px) {
    width: 95%;
    padding: 20px;
  }
  animation: ${fadeIn} 0.4s forwards cubic-bezier(0.25, 0.46, 0.45, 0.94);
  &.closing {
    animation: ${fadeOut} 0.4s forwards cubic-bezier(0.55, 0.085, 0.68, 0.53);
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
  h2 {
    margin: 0;
    font-size: 24px;
    color: #333;
  }
`;

export const ModalContent = styled.div`
  padding: 0 10px;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 20px;
  border-top: 1px solid #e9ecef;
`;

export const CompanyButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
    button {
      width: 100%;
    }
  }
`;

export const AddProposalContainer = styled.div.attrs({})`
  padding: 24px 0px;
`;

export const FormSelect = styled.select`
  width: 100%;
  padding: 12px;
  border: 1px solid #ced4da;
  border-radius: 8px;
  box-sizing: border-box;
  font-size: 19px;
  background-color: #f8f9fa;
  margin-bottom: 20px;
  color: #333333;
  text-align: center;
`;

export const Loader = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #007bff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: ${spin} 1s linear infinite;
  margin: 20px auto;
`;

export const LoaderText = styled.p`
  color: #333333;
  text-align: center;
  margin-top: 10px;
  font-size: 16px;
`;

export const AnalysisResultContainer = styled.div`
  background-color: #ffffff;
  color: #333333;
  border-radius: 12px;
  padding: 25px;
  margin-top: 25px;
  max-height: 40vh;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  &::-webkit-scrollbar {
    width: 8px;
    background-color: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 10px;
    &:hover {
      background-color: #555;
    }
  }
`;

export const AnalysisSection = styled.div`
  margin-bottom: 40px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const AnalysisCard = styled.div`
  background: #f0f0f0;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #000000ff;
`;

export const AnalysisItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const AnalysisIcon = styled.div`
  min-width: 24px;
  height: 24px;
  margin-right: 15px;
  svg {
    font-size: 24px;
    color: ${({ type }) => {
      switch (type) {
        case 'ok':
          return '#28a745';
        case 'warning':
          return '#ffc107';
        case 'error':
          return '#dc3545';
        case 'info':
          return '#17a2b8';
        default:
          return '#6c757d';
      }
    }};
  }
`;

export const AnalysisContent = styled.div`
  flex: 1;
`;

export const AnalysisTitle = styled.h4`
  margin: 0 0 15px 0;
  color: #000000ff;
  font-weight: 700;
  text-transform: capitalize;
`;

export const AnalysisText = styled.p`
  margin: 0;
  color: #555555;
  font-size: 18px;
  line-height: 1.6;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const AnalysisSectionTitle = styled.h3`
  margin: 6 0 15px 0;
  color: #333333;
  font-weight: 600;
  text-align: center;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 10px;
`;
